export const I18N_LOCALE_ROOT =
  "settings.billing.upgrade_modal_plan_details_with_proration" as const;
